import {
    Attachment,
    Avatar,
    Divider,
    FilesPdfColoredIcon,
    Flex,
    Image,
    OpenOutsideIcon,
    Skeleton,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components/macro";
import WelcomeImg from "../img/bgBulle.svg";

import Footer from "./Footer";
import DocumentComponent from "./DocumentComponent";
import { _preonboarding, _submitFactsheet } from "../api";
import { useQuery } from "react-query";

import { DEVICE, DEVICE_MAX } from "../../../constants/responsive";
import withAuth from "../../../HOC/withAuth";
import SCHeaderPreOnboarding from "./SCHeaderPreOnboarding";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import CardProgressFactsheet from "./CardProgressFactsheet";

const WelcomePreonboarding = () => {
    const navigate = useNavigate();
    const {
        isLoading: isLoadingData,
        isFetching,
        data,
    } = useQuery(["preonboarding_information"], () => _preonboarding());

    const isLoading = isLoadingData || isFetching;

    return (
        <FooterContent fill column>
            <SCHeaderPreOnboarding arrival_date={data?.me?.arrival_date} />
            <SFlexPage fill>
                <SFlexLeftCol>
                    <SFlexWelcomeBlock column>
                        {isLoading ? (
                            <Skeleton animation="pulse">
                                <Skeleton.Line width="80%" height="26px" />
                            </Skeleton>
                        ) : (
                            <STextWelcomeTitle
                                content={`Bonjour ${data?.me?.first_name}, et bienvenue chez nous ! 🎉`}
                            />
                        )}

                        <SFlexWelcomeBody>
                            {isLoading ? (
                                <Skeleton animation="pulse">
                                    <Flex gap="gap.smaller" column>
                                        <Skeleton.Line
                                            width="100%"
                                            height="18px"
                                        />
                                        <Skeleton.Line
                                            width="50%"
                                            height="18px"
                                        />
                                        <Skeleton.Line
                                            width="45%"
                                            height="18px"
                                        />
                                    </Flex>
                                </Skeleton>
                            ) : (
                                <>
                                    <STextWelcolmeDescription
                                        content={`Pour préparer votre arrivée dans les meilleures conditions, nous vous invitons à réaliser ces deux étapes avant votre premier jour :`}
                                    />
                                    <Text
                                        content={`1. Complétez votre fiche d'engagement`}
                                        className="strong"
                                    />
                                    <Text
                                        content={`2. Consultez et transmettez vos documents`}
                                        className="strong"
                                    />
                                </>
                            )}
                        </SFlexWelcomeBody>
                        {isLoading && (
                            <Skeleton animation="pulse">
                                <Flex
                                    styles={{
                                        marginBottom: "22px",
                                    }}
                                >
                                    <Skeleton.Line width="80%" height="48px" />
                                </Flex>
                            </Skeleton>
                        )}
                        {data?.contract_document_url?.length !== 0 &&
                            !isLoading && (
                                <Flex
                                    styles={{
                                        marginBottom: "22px",
                                    }}
                                >
                                    <Attachment
                                        actionable
                                        action={{
                                            icon: <OpenOutsideIcon />,
                                        }}
                                        icon={<FilesPdfColoredIcon />}
                                        header={`Contrat de travail de ${data?.me?.first_name}.pdf`}
                                        flat
                                        styles={{
                                            boxShadow: "none",
                                        }}
                                    />
                                    <DividerStyle />
                                </Flex>
                            )}
                        <SFlexContact>
                            {isLoading ? (
                                <Skeleton animation="pulse">
                                    <Flex gap="gap.medium">
                                        <Flex gap="gap.medium">
                                            <Skeleton.Avatar size="large" />
                                        </Flex>
                                        <Flex column vAlign="center">
                                            <Skeleton.Line
                                                width="126px"
                                                height="20px"
                                            />
                                            <Skeleton.Line
                                                width="100px"
                                                height="17px"
                                            />
                                        </Flex>
                                    </Flex>
                                </Skeleton>
                            ) : (
                                <Flex gap="gap.medium">
                                    <Avatar
                                        name={data?.hr?.name ?? ""}
                                        image={data?.hr?.avatar ?? ""}
                                        size="large"
                                    />
                                    <Flex column vAlign="center">
                                        <STextFullname
                                            content={data?.hr?.name ?? ""}
                                        />
                                        <STextJobTitle
                                            content={data?.hr?.job_title ?? ""}
                                        />
                                    </Flex>
                                </Flex>
                            )}
                            <SFlexContactRight>
                                {isLoading ? (
                                    <Skeleton animation="pulse">
                                        <Skeleton.Line
                                            width="120px"
                                            height="20px"
                                        />
                                        <Skeleton.Line
                                            width="100px"
                                            height="20px"
                                        />
                                    </Skeleton>
                                ) : (
                                    <>
                                        <STextLink
                                            as="a"
                                            href={`mailto:${
                                                data?.hr?.email ?? ""
                                            }`}
                                        >
                                            {data?.hr?.email ?? ""}
                                        </STextLink>
                                        <STextLink
                                            as="a"
                                            href={`tel:${
                                                data?.hr?.phone ?? ""
                                            }`}
                                        >
                                            {data?.hr?.phone ?? ""}
                                        </STextLink>
                                    </>
                                )}
                            </SFlexContactRight>
                        </SFlexContact>
                    </SFlexWelcomeBlock>
                    <SFlexWelcomeImageBlock>
                        <Flex hAlign="center" fill>
                            <ImageStyle src={WelcomeImg ?? ""} />
                        </Flex>
                    </SFlexWelcomeImageBlock>
                </SFlexLeftCol>
                <SFlexRightCol>
                    <CardProgressFactsheet
                        isLoading={isLoading}
                        completeness_percentage={
                            data?.me?.completeness_percentage
                        }
                        completeness_due_date={data?.me?.completeness_due_date}
                        completeness_status_id={
                            data?.me?.completeness_status_id
                        }
                        id_user={data?.me?.id}
                    />
                    <SFlexDocsBlock>
                        <DocumentComponent
                            data={data}
                            isLoading={isLoading}
                            isFetching={isFetching}
                        />
                    </SFlexDocsBlock>
                </SFlexRightCol>
            </SFlexPage>
            <Footer data={data} />
        </FooterContent>
    );
};

export default withAuth(WelcomePreonboarding);

const SFlexContactRight = styled(Flex)`
    flex-direction: column;
`;

const STextLink = styled(Text)`
    font-size: 12px;
    color: var(--purple);
    text-decoration: none;
    white-space: nowrap;
    :hover {
        text-decoration: underline;
    }
    @media ${DEVICE.mobileS} {
        margin-left: 0;
    }
    @media ${DEVICE.mobileL} {
        margin-left: auto;
    }
`;

const STextFullname = styled(Text)`
    font-size: 14px;
    font-weight: 700;
    color: var(--text);
`;
const STextJobTitle = styled(Text)`
    font-size: 12px;
    color: var(--text-sec);
    line-height: 1.4;
    margin-top: 1px;
`;
const SFlexContact = styled(Flex)`
    padding-top: 18px;
    border-top: 1px solid var(--border);
    justify-content: space-between;
    gap: 8px;
    @media ${DEVICE_MAX.laptop} {
        flex-direction: column;
    }
`;
const SFlexWelcomeBody = styled(Flex)`
    flex-direction: column;
    margin-bottom: 22px;
`;
const STextWelcolmeDescription = styled(Text)`
    font-size: 14px;
    color: var(--text-sec);
    line-height: 1.75;
    margin-bottom: 22px;
`;

const STextWelcomeTitle = styled(Text)`
    font-size: 20px;
    font-weight: 700;
    color: var(--text);
    margin-bottom: 10px;
    @media ${DEVICE.mobileS} {
        line-height: 24px;
    }
    @media ${DEVICE.mobileL} {
        line-height: 20px;
    }
`;

const SFlexPage = styled(Flex)`
    max-width: 1240px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    gap: 28px;
    align-items: stretch;
    @media ${DEVICE.mobileS} {
        flex-direction: column;
        padding: 8px 16px 32px;
    }
    @media ${DEVICE.tablet} {
        flex-direction: row;
        padding: 36px 32px 60px;
    }
`;
const SFlexLeftCol = styled(Flex)`
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
`;
const SFlexWelcomeBlock = styled(Flex)`
    background: white;
    border: 1px solid var(--border);
    border-radius: 14px;
    padding: 28px 32px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    flex-shrink: 0;
    .strong {
        color: var(--text);
        font-weight: 600;
        font-size: 14px;
        line-height: 1.75;
    }
`;
const SFlexWelcomeImageBlock = styled(Flex)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    flex: 1;
    min-height: 0;
    @media ${DEVICE_MAX.laptop} {
        display: none;
    }
`;
const SFlexRightCol = styled(Flex)`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-self: start;
    @media ${DEVICE.mobileS} {
        max-width: 100%;
    }
    @media ${DEVICE.tablet} {
        max-width: 400px;
    }
`;

const SFlexDocsBlock = styled(Flex)`
    background: white;
    border: 1px solid var(--border);
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

const FooterContent = styled(Flex)`
    background: var(--gb, #fafafa);
    min-height: 100vh;
`;

const ImageStyle = styled(Image)`
    @media ${DEVICE.mobileS} {
        display: none;
    }
    @media ${DEVICE.tablet} {
        display: none;
    }
    @media ${DEVICE.laptop} {
        display: flex;
        width: 381px;
        height: 276px;
    }
`;

const DividerStyle = styled(Divider)`
    @media ${DEVICE.mobileS} {
        display: none;
    }
    @media ${DEVICE.tablet} {
        display: none;
    }
    @media ${DEVICE.laptop} {
        display: none;
    }
`;
